import React from 'react';
import './LegalPages.css';

function TermsOfService() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Terms of Service</h1>
                <p className="last-updated">Last Updated: December 4, 2025</p>

                <section>
                    <h2>1. Service Description</h2>
                    <p>
                        This website provides free online image and PDF processing tools, including but not limited to image compression,
                        image resizing, image rotation, format conversion, PDF merging, PDF splitting, and other functions.
                    </p>
                    <p>
                        All processing is completed locally in your browser, and we do not upload, store, or access your files.
                    </p>
                </section>

                <section>
                    <h2>2. Terms of Use</h2>
                    <p>By using the services on this website, you agree to:</p>
                    <ul>
                        <li>Use this service for lawful purposes only</li>
                        <li>Not upload any illegal, harmful, threatening, abusive, or rights-infringing content</li>
                        <li>Not attempt to interfere with or disrupt the normal operation of the website</li>
                        <li>Not use automated tools to excessively request services</li>
                        <li>Comply with all applicable laws and regulations</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Intellectual Property</h2>
                    <p>
                        The design, code, text, graphics, and other content of this website are protected by copyright law and other intellectual property laws.
                        Without express permission, you may not copy,modify, distribute, or otherwise use such content.
                    </p>
                    <p>
                        Ownership of the files you upload and process always belongs  to you. We do not claim any rights to your files.
                    </p>
                </section>

                <section>
                    <h2>4. Disclaimer</h2>
                    <p>
                        This service is provided on an "AS IS" and "AS AVAILABLE" basis, without any express or implied warranties, including but not limited to:
                    </p>
                    <ul>
                        <li>Accuracy, reliability, or completeness of the service</li>
                        <li>Service will be uninterrupted or error-free</li>
                        <li>Processing results will meet your expectations</li>
                        <li>Defects in the service will be corrected</li>
                    </ul>
                    <p>
                        We recommend that you back up your original files before using this service to process important files.
                    </p>
                </section>

                <section>
                    <h2>5. Limitation of Liability</h2>
                    <p>
                        To the maximum extent permitted by law, we are not liable for the following:
                    </p>
                    <ul>
                        <li>Any direct, indirect, incidental, special, or consequential damages</li>
                        <li>Data loss or corruption</li>
                        <li>Business interruption or loss of profits</li>
                        <li>Any damages resulting from the use or inability to use this service</li>
                    </ul>
                </section>

                <section>
                    <h2>6. Service Changes and Termination</h2>
                    <p>
                        We reserve the right to modify, suspend, or terminate the service (or any part thereof) at any time without notice.
                        We are not liable for any modification, suspension, or termination of the service.
                    </p>
                </section>

                <section>
                    <h2>7. Advertising</h2>
                    <p>
                        This website may display third-party advertisements (such as Google AdSense). These advertisements are provided and managed by third parties,
                        and we are not responsible for the advertising content. Advertisers may use Cookies to provide relevant advertisements.
                    </p>
                </section>

                <section>
                    <h2>8. Links to Third-Party Websites</h2>
                    <p>
                        This website may contain links to third-party websites. We are not responsible for the content,
                        privacy policies, or practices of these websites. You access these links at your own risk.
                    </p>
                </section>

                <section>
                    <h2>9. Governing Law</h2>
                    <p>
                        These Terms of Service are governed by the laws of the People's Republic of China. Any disputes arising from these terms shall be resolved through friendly negotiation.
                    </p>
                </section>

                <section>
                    <h2>10. Changes to Terms</h2>
                    <p>
                        We may update these Terms of Service from time to time. Continued use of this service constitutes your acceptance of the revised terms.
                        Significant changes will be posted on the website.
                    </p>
                </section>

                <section>
                    <h2>11. Contact Us</h2>
                    <p>
                        If you have any questions about these Terms of Service, please contact us through our
                        <a href="/contact"> contact page </a>.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default TermsOfService;
